import { Hash } from 'lucide-react';
import { FormattedMessage } from 'react-intl';

export function EmptyState(): JSX.Element {
  return (
    <div className="text-center py-12">
      <div className="mx-auto max-w-sm">
        <Hash className="mx-auto h-12 w-12 text-gray-400" />
        <h3 className="mt-4 text-lg font-medium text-gray-900">
          <FormattedMessage id="integrations.messaging.slack.empty.title" />
        </h3>
        <p className="mt-2 text-gray-500">
          <FormattedMessage id="integrations.messaging.slack.empty.description" />
        </p>
      </div>
    </div>
  );
}
